/* eslint-disable jira/import-whitelist */
import { extractProjectKey } from '@jira/platform__issue-key-parsing/src/extractProjectKey.tsx';
import {
	getMainIssueViewAggQueryVariables,
	getMainIssueViewAggQueryFeatureFlagVariables,
} from '@jira/issue__main-issue-agg-query/src/getMainIssueViewAggQueryVariables.tsx';
import shadowMainIssueAggQuery from '@jira/issue__fetch-services-common/src/__generated__/shadowMainIssueAggQuery$parameters.ts';
import type { shadowMainIssueAggQuery as shadowMainIssueAggQueryType } from '@jira/issue__fetch-services-common/src/__generated__/shadowMainIssueAggQuery.graphql.ts';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import type { PreloadedQuery } from 'react-relay';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { RouteResource } from '@atlassian/react-resource-router';

export const shadowIssueViewRelayResource: RouteResource<
	PreloadedQuery<shadowMainIssueAggQueryType, Record<string, unknown>>
> = createRelayResource<shadowMainIssueAggQueryType>({
	type: 'ISSUE_RELAY_DATA_SHADOW',
	isBrowserOnly: true,

	getQuery: (routerContext, { tenantContext: { cloudId } }) => {
		const { match } = routerContext;
		const issueKey = getIssueKey(match) || routerContext.query?.selectedIssue || '';
		const projectKey = issueKey ? extractProjectKey(issueKey) : '';
		const queryVariables = {
			cloudId,
			issueKey,
			projectKey,
		};
		const limitFields = expVal('jpx-000-shadow-relay-query', 'limitFields', 99999) ?? 99999;
		return {
			parameters: shadowMainIssueAggQuery,
			variables: {
				...queryVariables,
				...getMainIssueViewAggQueryVariables(issueKey),
				limitFields,
			},
			// Pass over the variables that actually would trigger a reload when they are changed=
			keyVariables: {
				...queryVariables,
				...getMainIssueViewAggQueryFeatureFlagVariables(),
				limitFields,
			},
			options: {
				fetchPolicy: issueKey ? 'network-only' : 'store-only',
			},
		};
	},
});
